import React, { useCallback, useState } from 'react';
import PopingTask from '../doit/PopingTask';
import TaskEditor from '../planner/TaskEditor';
import './TaskCreator.css';

const TaskCreator = () => {
  const [popTaskData, setPopTaskData]   = useState(null);

  // ---  onPopTask ---
  //
  const onPopTask = useCallback((popTaskInfo) => {
    setPopTaskData(popTaskInfo);
  },[]);
  
  //------  Render  ------
  
  
  return (
    <div className='taskCreator'>
        <PopingTask popTaskData={popTaskData}/>
        <div className='taskCreatorLabel'>
          New Task
        </div>
        <TaskEditor onPopTask={onPopTask}/>      
    </div>
  );
};

export default TaskCreator;